import { SimpleTable } from '@core/components/Table';
import { TableActionButtonDelete, TableActionButtonEdit, TableActionContainer } from '@core/components/TableAction';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { DataBR } from '@format/DATA';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useContext } from 'react';
import { TransferenciaContext } from '../TransferenciaContext';
import TransferenciaFab from './TransferenciaFab';

const TransferenciaTable = ({ fetchData, cadastrar, editar, onExcluir, onSelecaoChange, onTour }) => {
  const [transferencias] = useContext(TransferenciaContext).transferencias;
  const [selecao] = useContext(TransferenciaContext).selecao;
  const [tipoSelecao, setTipoSelecao] = useContext(TransferenciaContext).tipoSelecao;
  const [totalElements] = useContext(TransferenciaContext).totalElements;
  const [, setPage] = useContext(TransferenciaContext).page;
  const [, setSize] = useContext(TransferenciaContext).size;
  const [, setSort] = useContext(TransferenciaContext).sort;
  const [loading] = useContext(TransferenciaContext).loading;

  const columns = [
    {
      name: 'origem.descricao',
      title: 'Conta origem',
      align: 'left',
      sortingEnabled: true,
      getCellValue: (transferencia) => transferencia?.origem,
    },
    {
      name: 'destino.descricao',
      title: 'Conta destino',
      align: 'left',
      sortingEnabled: true,
      getCellValue: (transferencia) => transferencia?.destino,
    },
    {
      name: 'valor',
      title: 'Valor (R$)',
      align: 'right',
      sortingEnabled: true,
      getCellValue: (transferencia) => getCurrency(transferencia?.valor),
    },
    {
      name: 'data',
      title: <div className="stepIconeOrdenacao">Data</div>,
      align: 'center',
      sortingEnabled: true,
      getCellValue: (transferencia) => DataBR(transferencia?.data),
    },
    {
      name: 'descricao',
      title: 'Descrição',
      align: 'left',
      sortingEnabled: false,
      getCellValue: (transferencia) => transferencia?.descricao,
    },
    {
      name: '',
      title: '',
      align: 'center',
      sortingEnabled: false,
      getCellValue: (transferencia) => {
        return (
          <>
            <TableActionContainer onTour={onTour}>
              {permissaoUtils.transferencia().editar && (
                <TableActionButtonEdit
                  className={'stepIconeEditar'}
                  onClick={() => editar(transferencia)}
                  title="Editar"
                />
              )}
              {permissaoUtils.transferencia().excluir && (
                <TableActionButtonDelete
                  className={'stepIconeExcluir'}
                  title="Excluir"
                  onClick={() => excluir(transferencia)}
                />
              )}
            </TableActionContainer>
          </>
        );
      },
    },
  ];

  const excluir = (transferencia) => {
    onExcluir({ ids: [transferencia] });
  };

  return (
    <>
      <SimpleTable
        // fetchOnCreate={false}
        defaultSorting={[{ columnName: 'data', direction: 'desc' }]}
        columns={columns}
        selection={selecao}
        onSelectionChange={onSelecaoChange}
        rows={transferencias}
        loading={loading}
        totalCount={totalElements}
        fetchData={fetchData}
        onCurrentPageChange={setPage}
        onPageSizeChange={setSize}
        onSortingChange={setSort}
        selectionType={tipoSelecao}
        onSelectionTypeChange={setTipoSelecao}
      />
      {(permissaoUtils.transferencia().cadastrar || permissaoUtils.transferencia().excluir) && (
        <TransferenciaFab selection={selecao} cadastrar={cadastrar} onExcluir={onExcluir} />
      )}
    </>
  );
};

export default TransferenciaTable;
